const state = {
  all: null,
  meta: null,
  error: null
}

const getters = {
  itemLog: state => state.all,
  itemLogMeta: state => state.meta,
  itemLogError: state => state.error
}

const actions = {
  getItemLog({ commit }, payload) {
    commit('setItemLog', payload)
  },
  getItemLogMeta({ commit }, payload) {
    commit('setItemLogMeta', payload.data)
  },
  getItemLogError({ commit }, payload) {
    commit('setItemLogError', payload.data)
  }
}

const mutations = {
  setItemLog(state, all) {
    state.all = all
    state.error = null
  },
  setItemLogMeta(state, meta) {
    state.meta = meta
  },
  setItemLogError(state, error) {
    state.error = error
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
